<template>
  <div class="flex gap-2 items-center" :class="{ 'w-full': plugin }">
    <div ref="container" class="flex flex-grow relative h-4">
      <div
        class="absolute w-full bg-secondary-lightest h-1 gd-range-slider-bar rounded-full"
      ></div>
      <div
        class="absolute bg-primary h-1 gd-range-slider-bar rounded-l-full"
        :style="{ width: activeWidth }"
      ></div>
      <input
        ref="input"
        type="range"
        :min="min"
        :max="max"
        :value="value"
        :step="step"
        class="w-full gd-range-slider absolute"
        @input="update"
      />
    </div>
    <input
      v-if="!corner"
      type="number"
      :value="value"
      :min="min"
      :max="max"
      @input="update"
      :readonly="readonly"
      class="px-1 bg-secondary border border-secondary-light rounded text-sm text-secondary-invert h-8 w-12 text-center focus:outline-none"
    />
    <input
      v-else-if="format"
      type="number"
      :value="formatted"
      @input="update"
      :readonly="readonly"
      class="px-1 bg-secondary border border-secondary-light rounded text-sm text-secondary-invert h-8 w-12 text-center focus:outline-none"
    />
  </div>
</template>

<script>

export default {
  name: 'GdSlider',
  props: {
    plugin: {
      type: Boolean,
      default: false 
    },
    value: {
      required: false,
    },
    min: {
      default: 1,
    },
    max: {
      default: 10,
    },
    step: {
      default: 1,
    },
    corner: {
      type: Boolean,
    },
    format: {
      required: false,
      default: false
    },
    formatValue: {
      type: Function,
      default: (value) => {
        return value;
      },
    },
    readonly: {
      required: false,
      default: true,
    },
  },
  data() {
    return {
      sliderWidth: 0,
    };
  },
  computed: {
    formatted() {
      return this.formatValue(this.value);
    },
    activeWidth() {
      const max = parseInt(this.max) - parseInt(this.min);
      let value = parseInt(this.value) - parseInt(this.min);
      if (value > max) value = max;
      const fraction = (this.sliderWidth / max) * value;
      return `${fraction}px`;
    },
  },
  mounted() {
    this.setSliderWidth();
    window.addEventListener('resize', () => {
      this.setSliderWidth();
    });
  },
  methods: {
    setSliderWidth() {
      setTimeout(() => {
        this.sliderWidth = this.$refs.container
          ? this.$refs.container.clientWidth
          : 0;
        if (this.sliderWidth === 0) this.setSliderWidth();
      }, 200);
    },
    update(e) {
      let val = e.target.value;
      e.target.value = val.replace(/[^0-9]+/g, '');
      if (val > this.max) {
        val = this.max + '';
        e.target.value = this.max;
      }
      if (val < this.min) {
        val = this.min + '';
      }
      this.$emit('input', val || this.min + '');
      this.$emit('change', val || this.min + '');
    },
  },
};
</script>
<style scoped>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>